export default {
	common: {
		day: 'Day',
		month: 'Month',
		year: 'Year',

		defaultSelectionValue: 'Please select',
		yesAnswer: 'Yes',
		noAnswer: 'No',

		// action
		ok: 'Ok',
		cancel: 'Cancel',
		delete: 'Delete',

		//button
		nextBtn: 'Next',
		verifyBtn: 'Verify',
		previousBtn: 'Previous',

		// step 3
		uploadFilesBtn: 'Upload Files',
		chooseFileBtn: 'Choose File',

		// step 4
		noToAllBtn: 'No To All',
		addConditionBtn: 'Add Condition',
		removeAnswer: 'Remove Answer',
		answer: 'Answer',

		//step 5
		buyNowBtn: 'BUY NOW',
		applyNowBtn: 'APPLY NOW',

		// contact us
		sendBtn: 'Send',
		closeBtn: 'Close',

		step1: 'Policy',
		step2: 'Quote',
		step3: 'Details',
		step4: 'Medical',
		step5: 'Apply',

		// check same policy
		samePolicy: 'Same as Policy Holder?',
	},

	popup: {
		childOnlyPolicy: 'Child Only Policy',
		childOnlyPolicyContent: `<p>
        </p>
          <p>
            Dependants / Children must be aged between 10 and 17 years old on a child only policy.
          </p>
        <p>
      </p>`,

		relationshipToThePolicyHolder: 'Why do we ask this?',
		relationshipToThePolicyHolderContent: `<p>
                                              Children can be added to a member's policy but they must be under 
                                              age 19 and unmarried (or under age 25, unmarried and in full-time 
                                              further education) at their start date.
                                            </p>
                                            <p>
                                              Children may remain covered under this policy until the annual 
                                              renewal date following their 19th birthday (or 25th birthday where in 
                                              full-time education) or marriage, at which time, their insurance cover
                                              under this policy will end and they may move onto their own policy.
                                            </p>
                                            <p>
                                              We offer Child Only policies only to children between the age of 10
                                              and 17. A compulsory excess applies to these policies of $/€/£ 100 per 
                                              claim.
                                            </p>
                                            <p>
                                              Any children under the age of 10 have to have an adult covered 
                                              on the policy.
                                            </p>`,

		KYCWording: 'Know Your Customer (KYC) documents',
		KYCWordingContent: `<ul style="list-style-type: none">
                        <li style="margin-bottom: 25px;">
                          <div style="margin-bottom: 8px;"> Proof of identity (picture version) </div>
                          Copy of one of the following <strong>for the Policy Holder and for each person to be insured</strong>:
                          <ul style="list-style-type: '- '">
                            <li>Valid Passport</li>
                            <li>Valid Drivers license</li>
                            <li>Valid Identity card</li>
                          </ul>
                        </li>
                        <li style="margin-bottom: 25px;">
                          <div style="margin-bottom: 8px;"> Proof of Address (if required) </div>
                          Copy of one of the following dated within 6 months of the inception date, and not including PO
                          Box addresses <strong>for the policy holder only</strong>:
                          <ul style="list-style-type: '- '">
                            <li>Recent utility bill</li>
                            <li>Bank or credit card statement</li>
                            <li>Reference from an Accountant, Lawyer, Bank Manager (template available on request).</li>
                          </ul>
                        </li>
                      </ul>`,

		confirmRemoveFamily: 'Confirm removal',
		confirmRemoveFamilyContent: 'Are you sure you want to remove this family member?',

		// step2
		excess: 'Excess',
		excessContent: `<p>
                      <p>
                        Excess is the amount you will have to pay towards any claim you make on your insurance. The Excess applies to each named individual on the policy.
                      </p>
                      <p>
                        For example, if you have an excess of £2,500 per person per year, you will have to pay the first £2,500 towards the cost of any claims you make. 
                        If you made a claim of £1,000 you pay the whole claim. 
                        If you then made another claim for £3,000 you would pay the first £1,500 and we would pay out the remaining £1,500.
                      </p>
                      <p>
                        The excess is not applicable to evacuation and repatriation, wellness benefits, cash benefits and dental benefits.
                      </p>
                    </p>`,
		
		coInsurance: 'Co-insurance',
		coInsuranceContent: `<p>
                          <strong style="padding-bottom: 1rem; display: inline-block;">Out-patient Co-insurance</strong>
                          <br>
                          By selecting this benefit you agree to pay the selected % of any costs incurred for all out-patient claims. (Out-patient claims are for example doctors visits, medication etc - please refer to the table of benefits for a full list of out-patient benefits).
                        </p>`,
						paymentFrequencyContent: `<p>
		It will cost more money to pay the insurance by instalments, a discount is applied if you pay for the insurance annually. 
						</p>`,
		paymentTitle : 'Payment  frequecy',										
		benefit: 'Benefits',
		homeEvacBenefitWording: `<div>
                        <p class="fw-bold">EVACUATION TO HOME COUNTRY – OPTIONAL BENEFIT </p>
                        <div>
                            <p>
                              The costs of emergency medical transportation and medical care en route for an insured person who has a critical medical condition and local medical facilities are inadequate or not available.
                            </p>
                            <p>
                              Transportation will be to the home country provided that it is a medically viable option, returning the insured person to their country of residence after treatment.
                            </p>
                        </div>
                        <p class="mb-1">If your home country is the United States of America, your policy will automatically terminate after 90 days in your home country.
                          Please note no cover is available:
                        </p>
                        <ul>
                          <li>If your home country is not within your selected area of cover shown on your certificate of insurance.  </li>
                          <li>Any subsequent transfer costs arising as a result of the same medical condition once we have returned the insured person to their home country.  </li>
                          <li>Travel costs unless specifically agreed by us and confirmed, in writing, prior to the date of travel.  </li>
                          <li>Evacuation costs where the insured person is not being admitted to a hospital for medical treatment, or where costs have not been approved by us prior to travel commencing.  </li>
                          <li>The transfer of a pregnant woman to hospital for routine childbirth, unless it is necessary due to medical complications.  </li>
                        </ul>
                      </div>`,
		flexibleChoicesBenefitWording: `<ul style="list-style-type: none;  ">
		<strong style="padding-bottom: 1rem; display: inline-block;">Flexible Choices Benefit Wording</strong>  
		<li>
		<p style="display: inline-block;text-decoration: underline">Out-Patient Module 1</p>
		<p>
		Covering everyday treatment with an annual limit of $2,500. 
		</p>
		 </li>
		<li>
		<p style="display: inline-block;text-decoration: underline">Out-Patient Module 2
		</p>
		<p>
		 Covering everyday treatment with an annual limit of $6,000.
		 </p>
		 </li>
		 <li>
		<p style="display: inline-block;text-decoration: underline">Dental Module
		</p>
		<p>
		 Covering Routine and Major Dental treatment.   
		 </p>
		 </li>
		 <li>
		 <p style="display: inline-block;text-decoration: underline">Maternity Module
		 </p>
		 <p>
		  Covering Routine Pregnancy & Childbirth, Complications and Premature Baby costs.     
		  </p>
		  </li>
		  <li>
		 <p style="display: inline-block;text-decoration: underline">Enhanced Network Module
		 </p>
		 <p>
		  Opinion to enhance your network to give free choice of medical providers.     
		  </p>
		  </li>
		</ul>`,

		underwriting: 'Help me choose',
		underwritingContent: `<p>
                            <p>We assess risks in different ways as shown below.</p>
                            <p class="fw-bold">a. Full Medical Underwriting</p>
                            <p>If you select Full Medical Underwriting (FMU), we will review the information provided to ascertain whether you and any eligible dependants will be accepted with or without specific exclusions or terms.</p>
                            <p>Any pre-existing conditions not declared on your FMU application may not be covered by your policy.</p>
                            <p>If a specific exclusions or terms will apply to your policy, we will advise you in writing and you will need to confirm to us in writing that you accepted the terms offered before your policy can start.</p>

                            <p class="fw-bold">b. Moratorium Underwriting</p>
                            <p>Moratorium Underwriting is only available if you and any eligible dependants are under age 55 at the start date of the policy.</p>
                            <p>Moratorium Underwriting means that you and eligible dependants will not be covered for any pre-existing conditions that have been in existence during 5-year period before your start date. After 2 years continuous cover, pre-existing medical conditions may become eligible for cover (unless the condition is specifically excluded by the policy) if, at the first time of receiving treatment, you/your dependant has not:</p>
                            <ul class="fw-bold">
                              <li>Suffered any symptoms;</li>
                              <li>Consulted any medical practitioner for check-ups/ monitoring of a condition, received follow-up examinations, medical treatment or advice;</li>
                              <li>Been prescribed or taken medicine, including over the counter drugs, special diets, injections or physiotherapy;</li>
                              <li>And, you were not reasonably aware the condition existed.    </li>
                            </ul>
                            <p>If there is any doubt over whether a condition existed prior to the start date of the policy, we reserve the right to request a further medical opinion. The final decision on whether a condition is covered rests solely with our Chief Medical Officer (CMO).</p>
                          </p>`,

		// step 5
		paymentSuccessTitle: 'Accepted',
		paymentSuccess: `<p>Congratulations! Your application has been successful.</p>
          <p>Thank you for purchasing a Morgan Price Health Insurance Policy. This will provide you with hassle free cover for the duration of the policy.</p>
          <p>Please carefully check the Policy Certificate we have sent to you by email.</p>
          <p>You can download our App here: <a href="https://www.morgan-price.com/app/">https://www.morgan-price.com/app/</a></p>`,

		paymentDeclinedTitle: 'Declined',
		paymentDeclined: `Your Payment has been declined. Please either try to pay again or select Apply Now and one of our Team will be in contact with you shortly to finalize setting up your policy.`,

		paymentExceptionTitle: 'Exception',
		paymentException:
			'There may have been a problem with your payment. Please do not attempt to pay again. If the payment has failed our Team will be in contact with you shortly.',
		applySuccessMessage: 'Apply success',
		applySuccessDeclinePaymentMessage: `<p>
			Thank you for applying for a Morgan Price Healthcare product.
			As you have declined to pay online your application will be reviewed by one of our Team who will contact you shortly.
			Thank you for your patience.
			</p>`,
		applySuccessWithYesAnswerMessage: `<p>
			Thank you for applying for a Morgan Price Healthcare Product.
			Because you have answered 'Yes' to some questions the application must be reviewed by one of our team who will contact you shortly.
			Thank you for your patience.
			</p>`,
	},

	validate: {
		validateAgeRelationshipPolicy: `Please select 'Relationship To The Policy Holder' first.`,
		requiredField: 'The field is required',

		// validation messages
		phoneNumber: 'Please enter valid phone number.',
		checked: 'Please tick the checkbox.',
		currencyPayIn: 'Date must be between today and no more than 30 days in the future.',
		dayBeforeToday: 'Date must be <= today',
		appSelectRequired: 'The field is required',
		bmi: 'Must be number.',
		cms: 'Must lie between 1 and 300',
		feets: 'Must lie between 0 and 9',
		inches: 'Must lie between 0 and 11',
		kgs: 'Must lie between 1 and 300',
		pounds: 'Must lie between 0 and 13',
		stones: 'Must lie between 0 and 47',
		genderId: 'Please select your gender',
		occupationId: 'Please select your occupation',
	},

	notify: {
		// app.vue
		fillRequiredField: 'Please input required fields',

		//step 2
		quoteUpdated: 'Quote Updated!',
		selectPackage: 'Please select package',
		selectProduct: 'Please select product',
		selectUnderwritingType: 'Please select underwriting type',

		//step 3
		fileUploadEmpty: 'File is empty, not upload.',
		fileUploadSuccess: 'Upload success!',

		//step 5
		notCheckError: 'Please tick on the box',
		waitProcessing: 'Processing, please wait...',
		cannotApply: `Can't not apply, please check your information`,
	},

	emailContent: {
		customerBody: `<div style='width: 850px;'>
                    <p>Dear {customerName},</p>
                    <p style='margin-left: 300px;'>Congratulations!</p>
                    <p>Thank you for your application for a Morgan Price policy. We are pleased to confirm cover for the coming year.</p>
                    <p>Attached to this email you will find your password protected Policy Certificate, together with your Member card(s), Insurance Product Information Document and Table of Benefits.</p>
                    <p>The password is your date of birth in the following format DDMMYYYY.</p>
                    <div style="margin-bottom: 30px;"></div>
                    <p>The full policy wording can be downloaded from
                      <a href="{policyWordingUrl}">here</a>
                    </p>
                    <p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
                    <p>We thank you for taking out your insurance with Morgan Price International Healthcare and look forward to providing our best service to you as a customer.</p>
                  </div>`,
		customerBodyForBrokerOverride: `<div style='width: 850px;'>
									 <p>Dear Intermediary Partner,</p>
									 <p style='margin-left: 300px;'>Congratulations!</p>
									 <p>Thank you for your application for a Morgan Price policy. We are pleased to confirm cover for the coming year for {customerName}.</p>
									 <p>Attached to this email you will find the password protected Policy Certificate, together with the Member card(s), Insurance Product Information Document and Table of Benefits.</p>
									 <p>The password is the Policy Holders date of birth in the following format DDMMYYYY.</p>
									 <div style="margin-bottom: 30px;"></div>
									 <p>The full policy wording can be downloaded from
										<a href="{policyWordingUrl}">here</a>
									 </p>
									<p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
									<p>We thank you for taking Morgan Price International Healthcare Insurance and look forward to providing our best service to you.</p></div>`,
		customerBodyForBrokerWithNoOverride: `<div style='width: 850px;'>
											<p>Dear {customerName},</p>
											<p style='margin-left: 300px;'>Congratulations!</p>
											<p>Thank you for your application for a Morgan Price policy. We are pleased to confirm cover for the coming year.</p>
											<p>Attached to this email you will find your password protected Policy Certificate, together with your Member card(s), Insurance Product Information Document and Table of Benefits.</p>
											<p>The password is your date of birth in the following format DDMMYYYY.</p>
											<div style="margin-bottom: 30px;"></div>
											<p>The full policy wording can be downloaded from
											<a href="{policyWordingUrl}">here</a>
											</p>
											<p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
											<p>We thank you for taking out your insurance with Morgan Price International Healthcare and look forward to providing our best service to you as a customer.</p>
											</div>
											`,
		applyNowCustomerBody: `<div style='width: 850px;'>
                    <p>Dear {customerName},</p>
                    <p>Thank you for your application for a Morgan Price policy.</p>
                    <p>Attached to this email you will find your application form.</p>
                    <p>The password is your date of birth in the following format DDMMYYYY.</p>
                    <div style="margin-bottom: 30px;"></div>                    
                    <p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
                    <p>One of our Team will be in contact with you shortly.</p>
                  </div>`,
		applyNowCustomerBodyForBrokerOverride: `<div style='width: 850px;'>
											 <p>Dear Intermediary Partner,</p>
											 <p>We have received an online application for the client {customerName}.</p>
											 <p>Attached to this email you will find their application form.</p>
											 <p>The password is their date of birth in the following format DDMMYYYY.</p>
										     <div style="margin-bottom: 30px;"></div>
											 <p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
											 <p>One of our Team will be in contact with you shortly.</p></div>`,
		applyNowCustomerBodyForBrokerWithNoOverride: `<div style='width: 850px;'>
													<p>Dear {customerName},</p>													
													<p>Thank you for your application for a Morgan Price policy.</p>
													<p>Attached to this email you will find your application form.</p>
													<p>The password is your date of birth in the following format DDMMYYYY.</p>
													<div style="margin-bottom: 30px;"></div>
													<p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>													
													<p>One of our Team will be in contact with you shortly. </p>
													</div>
													`,
	},

	layout: {
		header: {
			contactUs: 'CONTACT US',
		},

		footer: {
			aboutUs: 'About Us',
			app: 'App',
			appTerms: 'App Terms',
			complaints: 'Complaints',
			news: 'News',
			careers: 'Careers',
			privacyPolicy: 'Privacy Policy',
			cookiePolicy: 'Cookie Policy',
			termsConditions: 'Terms & Conditions',
			FAQ: 'FAQ',
			sitemap: 'Sitemap',
			downloads: 'Downloads',
		},
	},

	step1: {
		header: {
			titleBold: "It's quick and easy to apply for Individuals or Families.",
			titleContent: `Depending on the Underwriting type you choose you may need to provide the full medical history of each applicant. 
        {br}Currently applications cannot be saved part way through so please ensure you have all necessary information to hand. 
        {br}If you would like to apply for a corporate or business group {contactLink} and our sales team will be in touch to assist.
        {br}Brokers and Intermediaries - don't forget to to use the unique link we have provided to you.
        {br}All cover is subject to compulsory Know Your Customer checks. You will need to upload some proof of ID documents during this application process.`,
			linkContent: 'click here',
		},
		broker: 'Broker:',
		// Policy Holder
		policyHolderTitle: 'Policy Holder Details',
		policyHolderDesc: 'Please tell us a bit about the policy holder',
		title: 'Title',
		forename: 'Forename',
		surname: 'Surname/Family Name',
		dob: 'Date Of Birth (DD/MM/YYYY)',
		gender: 'Gender',
		occupation: 'Occupation',
		residenceCountry: 'Country for which this cover is required (where you will be spending most of your time)',
		nationalityCountry: 'Country of Nationality (Country of Primary Passport)',
		tax: 'Tax Identification Number',
		jobTitle: 'Job Title',
		industry: 'Industry',
		isPolicyInsured: 'Is the Policy Holder to be Insured?',

		// Policy Holder Contact Details
		contactDetailsTitle: 'Policy Holder Contact Details',
		contactDetailsDesc:
			'We require your contact details. Please provide at least one of the below. Without this information we will not be able to administer your policy or support you in the event of a claim.',
		internationalDialingCode: 'International dialing code',
		landlineNumber: 'Landline Number',
		internationalDialingCodeList: 'International dialing code',
		mobileNumber: 'Mobile Number',
		emailAddress: 'Email Address',

		// Additional Family Members
		additionalFamilyTitle: 'Additional Family Members',
		addFamilyBtn: 'Add Family Members',
		familyMember: 'Family member #',
		relationshipToThePolicyHolder: 'Relationship To The Policy Holder',

		// Policy Details
		policyDetailsTitle: 'Policy Details',
		policyStartDate: 'On Which Date Do You Require The Policy To Start? (DD/MM/YYYY)',
		currencyPayIn: 'What Currency Do You Wish To Pay In?',
	},

	step2: {
		// if print
		product: 'Product:',
		area: 'Area',
		frequency: 'Frequency',
		// not print
		selectProduct: 'Select Product',
		selectAreaOfCover: 'Select Area Of Cover',
		selectPaymentFrequency: 'Select Payment Frequency',
		selectLevelOfCover: 'Select Level Of Cover',
		excludingTax: 'Excluding Tax',
		chooseAnExcess: 'Choose an Excess',
		coInsurance: 'Co-insurance',
		coInsuranceDefault: '0% co-insurance on all out-patient claims',
		additionalBenefits: 'Additional Benefits',
		selectUnderwritingType: 'Select Underwriting Type',
		selectUnderwritingDesc: {
			pleaseNote: 'Please note: ',
			desc: `it is very important you understand the difference between the
      types of underwriting and that you chose the option that is right for you.`,
			helpMeChoose: 'HELP ME CHOOSE',
		},

		//control
		updateQuoteBtn: 'Update Quote',
		IPID: 'Insurance Product Information Document',
		ToB: 'Table of Benefits',

		// product not available
		productNotAvailable: 'This Product is only available in ',

		//aria
		getProductDocuments: 'Get product documents',
	},

	step3: {
		residenceAddress:
			'Address in country for which this cover is required (where you will be spending most of your time).',
		countryAddress: 'Home Country Address (Country Of Your Primary Passport)',
		addressDesc: 'If you have an address in this Country, please add it here',
		//address form
		address1: 'Address Line 1',
		address2: 'Address Line 2',
		address3: 'Address Line 3',
		stateCountry: 'State/County',
		city: 'City',
		zipCode: 'ZIP/ Postal Code',
		country: 'Country',

		// policy detail
		policyHolder: 'Policy Holder',
		policyNotInsured: 'Policy Holder is not to be Insured on this policy',

		// bmi
		units: 'Units',
		metric: 'Metric',
		imperial: 'Imperial',
		height: 'Height',
		weight: 'Weight',
		statusRefer: 'Status refer:',

		// Supplementary Questions
		supplementaryQuestions: 'Supplementary Questions',
		pastime: 'Do you engage in a hazardous or contact sport or any sport more than once a week?',
		pastimeAsk: `Sport or Pastime (For the avoidance of doubt this would include amongst other 
      things but not limited to ANY contact sport, Climbing without ropes, Horse Jumping of any kind, 
      Surfing, Kite Surfing, Free Diving, Scuba diving at more than 40m depth, 
      Diving from more than 10m, Tombstoning, Off Piste winter sports or Using a firearm of any kind).`,
		pastimeAskText: `If you are in any doubt then you should disclose your sport or physical pastime.`,
		smoke: 'Do you smoke?',
		smokeAsk: 'Please enter how many per day?',
		companyInsured:
			'Has This Person Ever Been Refused Cover By An Insurance Company Or Been Accepted On Special Terms?',
		companyInsuredAskDate: 'Date',
		companyInsuredAskDetails: 'Enter Details',

		// Physician Details
		physicianDetails: 'Physician Details',
		policyNotInsuredPhysician:
			'Policy Holder is not to be Insured on this policy Skip to Family Members as following questions are not required',
		physicianDesc: `Please provide us with the name and address of your regular personal or family doctor/physician. If you do not
      have a regular doctor, please give the last doctor you visited and approximate date.`,
		// policy form same step 1
		salutations: 'Salutations',
		practiceName: 'Practice Name',
		dateLastVisited: 'Date Last Visited (DD/MM/YYYY)',
		email: 'Email',
		countryCode: 'Country Code',
		telNumber: 'Telephone Number',

		haveExistInsured: 'Do you have Existing Health Insurance Policies?',
		haveExistInsuredDate: 'Date Cover Ends',
		haveExistInsuredCompanyName: 'Provider company name',

		// documents
		proofOfIdentity: 'Proof of identity',
		proofOfAddress: 'Proof of address',
		uploadDocument: 'Upload Documents for proof of identity',
		uploadDocumentDesc1: `We are required to collect proof of your identity for Know Your Customer (KYC) regulations. If you are using a
      mobile device please use your camera to take a picture of your document or upload a picture of your document.`,
		uploadDocumentDesc2: `Allowed file formats are pdf, docx, doc, rtf, bmp, gif, jpg, jpeg, and png with a maximum size of 2 MB.`,
		// tutorial upload documents
		uploadDocumentTutorial: 'To upload documents:',
		uploadDocumentStep1: 'Click choose file',
		uploadDocumentStep2: 'Add as many documents as requested',
		uploadDocumentStep3: 'When ALL documents have been selected, select Upload Files',

		familyMembers: 'Family Members',
	},

	step4: {
		underwritingQuestions: 'Underwriting Questions',
		medicalDeclaration: 'Medical Declaration', // Name of group question
		//medical treatment
		additionalInformation: 'Additional information:',

		// other group question
		illnessMedicalNameCondition: `Name of illness/medical condition. Where applicable, please state the area of the body affected (e.g. left or right arm)`,
		dateStarted: 'Date started',
		dateEnded: 'Date ended',
		medicalTreatment: 'What medical treatment was provided?',
		currentMedicationAndDose: 'Current medication name and daily dose',
		stayHospitalWithThisCondition: 'Have you ever had a hospital stay in relation to this condition?',
		currentStatus: 'Current Status',
	},

	step5: {
		summary: 'Summary',
		policyNumber: 'Policy Number',
		productName: 'Product',
		areaOfCover: 'Area of Cover',
		levelOfCover: 'Level of Cover',
		excess: 'Excess',
		voluntaryExcess: 'Voluntary Excess',
		mandatoryExcess: 'Mandatory Excess',
		notApplicable: 'Not Applicable',
		additionalBenefits: 'Additional Benefits',
		coInsurance: 'Co-insurance',
		noneSelected: 'None selected',
		underwritingType: 'Underwriting Type',
		noneAvailable: 'None available',
		pricingTable: 'Pricing table',
		premiumWithoutTax: 'Annualised Premium',
		VAT : 'VAT (based on Country of Residence)',
		paymentFrequencyDividedByHeader : 'There will be',
		paymentFrequencyDividedByBody : ' further payments of',
		totalTax: 'Total Tax (based on country of Residence)',
		totalSurcharge: 'Total Surcharge',
		totalPremium: 'Total Premium',
		chosen : 'You have chosen to pay',
		nonAnnualPayment : 'The first payment will be',
		annualPayment : 'There will be a one off payment of',
		paymentFrequency: 'Payment Frequency',
		firstPayment: 'First payment',
		amountHeader : ' The first payment will be',
		amountBody : 'further payments of',
		subsequentPayment: 'Subsequent payment',
		checkIPID: 'Please confirm that you have read the',
		IPID: 'Insurance Product Information Document',
		declarationAndData: 'Declaration and Data Protection Declaration',
		customerConsentHeader : 'I agree to receiving documents electronically.',
		customerConsentBody : 'Consumer consent',
		declaration: 'Declaration',
		checkDeclaration: 'I have read and accepted the terms of this',

		verifyDesc: 'You have this/these option(s) to proceed:',
		verifyBuyNowDesc: `If you wish to purchase the policy with a Debit/Credit Card select Buy Now below. 
          This will take you to Barclays Bank payment processing. 
          Please note that Policy acceptance is still subject to a satisfactory Know Your Customer outcome.`,
		verifyApplyNowDesc: `If you do not wish to pay by Debit/Credit Card, 
          select Apply Now, and one of our Team will be in contact with you shortly to finalise setting up your policy.`,

		applyNowDesc: `This application needs to go to our Underwriters for review before we can provide a final Premium. 
          The premium shown is indicative only.`,
	},

	previewForm: {
		details: 'Your Details',
		contact: 'Contact Details',
		residence: 'Country Of Residence Address',
		home: 'Home Country Address',
		physic: 'Physician Details',
		underwritingQuestion: 'Underwriting Questions',
	},

	contactUs: {
		title: 'Contact Us',
		desc: 'Unfortunately we are unable to quote for your particular circumstances online. Please contact us by email for a quotation.',
		name: 'Name',
		age: 'Age',
		residenceCountry: 'Country of residence',
		numberDesc: 'We can call you if you would prefer - please provide your number',
		countryCode: 'Country Code',
		number: 'Number',
		contactTimeDesc: 'and a preferred time that you would like us to call (we are open 9am-5.00pm UK time)',
	},

	months: [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	],
}
